import { DropdownField, IStyleConfig } from '@cian/components';
import * as React from 'react';
import { IJsonQuery } from '../../../json_query';
import { dealTypeFromJsonQuery, FDealType } from '../../../utils/category';

const style = require('./index.css');

export interface IDealTypeProps {
  jsonQuery: IJsonQuery;
  buttonStyle?: IStyleConfig;

  onDealTypeChanged(value: FDealType): void;
}

export class DealType extends React.Component<IDealTypeProps> {
  public render() {
    const { jsonQuery, buttonStyle, onDealTypeChanged } = this.props;
    let dealType = dealTypeFromJsonQuery(jsonQuery);
    if (dealType === FDealType.Rent) {
      dealType = FDealType.RentLongterm;
    }

    return (
      <DropdownField
        theme="button/blue"
        buttonStyle={buttonStyle}
        containerStyle={style['popupContainer']}
        value={dealType}
        onValueChange={onDealTypeChanged}
        values={[
          { value: FDealType.Sale, label: 'Купить' },
          { value: FDealType.RentLongterm, label: 'Снять' },
          { value: FDealType.RentDaily, label: 'Посуточно' },
        ]}
        dataMark="dealType"
      />
    );
  }
}
